import { FileManagementExtensionService } from 'src/app/shared/services/file-management-extension-service/file-management-extension.service';
import { PlanningReportService, PropertyListingService } from 'src/app/services/property-matrixV2/services';
import { ReportDocumentDto, SellMyPropertyDocumentDto } from 'src/app/services/property-matrixV2/models';
import { NotificationService } from 'src/app/shared/services/notification-service/notification.service';
import { AdvertGeneratorDto } from 'src/app/services/property-matrixV2/models/advert-generator-dto';
import { PropertyListingDto } from 'src/app/services/property-matrixV2/models/property-listing-dto';
import { AdvertService } from 'src/app/services/property-matrixV2/services/advert.service';
import { MatDialog } from '@angular/material/dialog';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { catchError, finalize, of } from 'rxjs';
import { LeafletContactBrokerAgentComponent } from '../../../../shared/components/leaflet-contact-broker-agent/leaflet-contact-broker-agent.component';

@Component({
  selector: 'app-property-sell-details',
  templateUrl: './property-sell-details.component.html',
  styleUrls: ['./property-sell-details.component.scss', '../../../../../css/styles.scss']
})
export class PropertySellDetailsComponent implements OnInit {
  property: PropertyListingDto;
  advertDetails: AdvertGeneratorDto;
  sellPropertyDocuments: SellMyPropertyDocumentDto[] = [];
  additionImages: SellMyPropertyDocumentDto[] = [];
  documents: ReportDocumentDto[] = [];
  emails = [
    { label: 'BROKER / AGENT', email: 'broker@propertymatrix.co.za' },
    { label: 'CONTACT PLANNER', email: 'planner@propertymatrix.co.za' },
    { label: 'CONTACT LEGAL TEAM', email: 'planner@propertymatrix.co.za' },
    { label: 'BOND ORIGINATOR', email: 'manager@propertymatrix.co.za' }
  ];
  items = [];

  currentIndex = 0;
  itemsPerSlide = 3;
  placeholderImage = '../../../../assets/images/placeholders/property-matrix-placeholder.png';
  loading = false;
  urlForProperty = "";
  isLeafletType: boolean = false;
  planningReportFileURL: string = "";
  selectedImage: { image: string; title: string } | null = null;
  ImageFileUrl: string = "";

  constructor(

    private advertService: AdvertService,
    private notificationService: NotificationService,
    private planningReportService: PlanningReportService,
    private propertyListingService: PropertyListingService,
    private fileManagementService: FileManagementExtensionService,
    public dialog: MatDialog,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit(): void {

    const propertyId = this.route.snapshot.queryParamMap.get('id');
    const advertId = this.route.snapshot.queryParamMap.get('ai');
    this.getPropertyById(propertyId);
    this.getAdvertDetails(advertId);
  }

  getPropertyById(propertyId: any) {
    this.propertyListingService.apiV1PropertyListingGetPropertiesByPropertyIdPost({ propertyListingId: propertyId }).subscribe({
      next: (response: PropertyListingDto[]) => {
        if (response.length === 0) {
          this.notificationService.showErrorMessage('Error', 'Property not found');
          return;
        }
        else {
          this.property = response[0];
          this.getAdditionalImages();
          this.getDocuments();
        }
        this.checkPropertyListingType();
      },
      error: (error) => {
        console.error('Error fetching property:', error);
        this.notificationService.showErrorMessage('Error', 'Failed to load property details');
      }
    });
  }

  backToMaps() {
    window.history.back();
  }

  getAdvertDetails(advertId: any) {
    this.advertService.apiV1AdvertGetAdvertGeneratorReportDataWithIdGet({ advertGeneratorId: advertId }).subscribe((res) => {
      this.advertDetails = res;

      this.getFileURLWithFileId(this.advertDetails.propertyImageFileId!, 'image');

      if (this.advertDetails.advertKeyFeatures == null) {
        this.advertDetails.advertKeyFeatures = [
          { description: 'No Key Features' },
        ];
      }
      this.getPlanningReportUploadedOnAdvertGenerate(this.advertDetails);

      this.getSellPropertyDocuments();
    });
  }

  private getFileURLWithFileId(fileId: string, fileType: string): void {
    this.fileManagementService.apiV1FileManagementGetFileFileIdGet({ fileId: fileId })
      .subscribe((result: any | void) => {
        if (result) {
          this.ImageFileUrl = result?.split('?')[0] ?? result;
        } else {
          this.ImageFileUrl = this.property?.image?.split('?')[0] ?? this.property?.image;
        }
      });
  }

  getSellPropertyDocuments() {
    this.advertDetails.advertGenerateAdditionalImages.forEach(element => {

      let imageUrl = '';
      this.fileManagementService.apiV1FileManagementGetFileFileIdGet({ fileId: element.id })
            .subscribe((result: any | void) => {
              if (result) {
                imageUrl = result?.split('?')[0] ?? result;
      this.items.push({ image: imageUrl, title: element.description });
              }
            });

    });
  }

  getAdditionalImages() {
    if (this.property === null || this.property === undefined) {
      this.notificationService.showInfoMessage('Notice', 'The planning report needs to be exported before documents will be available here.');
    } else {
      this.loading = true;
      this.planningReportService.apiV1PlanningReportGetReportUploadedSellPropertyDocumentsGet({
        propertyDetailId: this.property.propertyDetail?.id
      }).subscribe({
        next: (UploadedDocument: SellMyPropertyDocumentDto[]) => {
          if (UploadedDocument) {
            this.additionImages = UploadedDocument;
          }
          this.loading = false;
        },
        error: (_error: any) => {
          this.notificationService.showErrorMessage('Error', 'Could not load Sell property uploads.');
          this.loading = false;
        }
      });
    }
  }

  getDocuments() {
    if (this.property === null || this.property === undefined) {
      this.notificationService.showInfoMessage('Notice', 'The planning report needs to be exported before documents will be available here.');
    } else {
      this.loading = true;
      this.planningReportService.apiV1PlanningReportGetReportDocumentsGet({
        planningReportId: this.property.planningReport.id
      }).subscribe({
        next: (documents: ReportDocumentDto[]) => {
          this.documents = documents;
          this.loading = false;
        },
        error: (_error: any) => {
          this.notificationService.showErrorMessage('Error', 'Could not load report documents.');
          this.loading = false;
        }
      });
    }
  }

  prevSlide() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      console.log('Current index:', this.currentIndex);
    }
  }

  nextSlide() {
    if (this.currentIndex < this.items.length - this.itemsPerSlide) {
      this.currentIndex++;
      console.log('Current index:', this.currentIndex);
    }
  }

  getVisibleItems() {
    return this.items.slice(this.currentIndex, this.currentIndex + this.itemsPerSlide);
  }

  GetReportFile() {
    if (this.documents.length > 0) {
      const latestDocument = this.documents.reduce((prev, current) => {
        return (prev.createdDate > current.createdDate) ? prev : current;
      });
      window.open(latestDocument.downloadUrl, '_blank');
    }
  }

  public downloadPlanningReport(): void {
    if (this.planningReportFileURL) {
      window.open(this.planningReportFileURL, '_blank');
    } else {
      this.notificationService.showErrorMessage("Error", "Could not download planning report.");
    }
  }

  sendMakeAnOfferEmail() {
    const currentUrl = window.location.href;
    const subject = 'Property Matrix - Make an Offer';
    const body = `Hello,\n\nI would like to get more information about the property ${this.property?.propertyDetail?.propertyDescription}.\n\n Link to property here:${currentUrl}\n\nThank you!`;
    window.location.href = `mailto:broker@propertymatrix.co.za?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  }

  sendEmail(email: any) {
    if (email.label == "BROKER / AGENT" && this.isLeafletType == true) {
      this.openLeafletPopupDialog();
    } else {
      const currentUrl = window.location.href;
      const subject = 'Property Matrix - Property Details';
      const body = `Hello,\n\nI would like to get more information about the property ${this.property?.propertyDetail?.propertyDescription}.\n\n Link to property here:${currentUrl}\n\nThank you!`;
      window.location.href = `mailto:${email.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    }
  }

  sendEmailToFriend() {
    const currentUrl = window.location.href;
    const subject = 'Property Matrix - Property Details';
    const body = `Hello,\n\nI would like to share the property with you. You can view it here:${currentUrl}\n\nThank you!`;
    window.location.href = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  }

  shareOnInstagram() {
    const currentUrl = window.location.href;
    navigator.clipboard.writeText(currentUrl).then(() => {
      this.notificationService.showSuccessMessage(
        'Link Copied!',
        'Property link copied to clipboard. Open Instagram and paste it in your story or post.'
      );
      // Open Instagram website - user can then share manually
      window.open('https://www.instagram.com/', '_blank');
    }).catch(() => {
      this.notificationService.showErrorMessage('Error', 'Could not copy link to clipboard.');
    });
  }

  shareOnFacebook() {
    const currentUrl = window.location.href;
    const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}`;
    window.open(facebookShareUrl, '_blank', 'width=600,height=400');
  }


  shareOnTwitter() {
    const currentUrl = window.location.href;
    const tweetText = 'Check this out!'; // Optional custom text
    const twitterShareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(currentUrl)}&text=${encodeURIComponent(tweetText)}`;
    window.open(twitterShareUrl, '_blank', 'width=600,height=400');
  }

  private checkPropertyListingType(): void {
    if (this.property && this.property.listingType) {
      if (this.property.listingType == "LEAFLET") {
        this.isLeafletType = true;
      } else {
        this.isLeafletType = false;
      }
    } else {
      this.notificationService.showWarningMessage("Warning", "This property listing does not have a property listing type.");
      this.isLeafletType = false;
    }
  }

  private openLeafletPopupDialog(): void {
    this.dialog.open(LeafletContactBrokerAgentComponent);
  }

  private getPlanningReportUploadedOnAdvertGenerate(advertGeneratedDto: AdvertGeneratorDto): void {
    if (advertGeneratedDto.propertyReportFileId) {
      this.fileManagementService.apiV1FileManagementGetFileFileIdGet({ fileId: advertGeneratedDto.propertyReportFileId })
        .pipe(
          catchError((err) =>
            of(this.notificationService.showErrorMessage("Error", "Could not get the advert develop-able data."))
          ),
          finalize(() => {
            this.loading = false;
          })
        )
        .subscribe((result: string | void) => {
          if (result) {
            this.planningReportFileURL = result;
          } else {
            this.notificationService.showErrorMessage("Error", "Could not get the advert generated planning report uploaded.");
          }
        });
    } else {
      this.notificationService.showWarningMessage("Warning", "This property listing does not have a planning report uploaded.");
    }
  }

  public openImagePopup(item: { image: string; title: string }) {
    this.selectedImage = item;
  }

  public closeImagePopup() {
    this.selectedImage = null;
  }

  public getPropertyPriceDisplay(price: number | string): string {
    if (price == null || price === '') return '';

    const num = typeof price === 'string' ? parseFloat(price.replace(/[^0-9.-]+/g, '')) : price;

    if (isNaN(num)) return '';

    if (num >= 1000000) {
      const millions = Math.round((num / 1000000) * 10) / 10;
      return `R${millions}m`;
    } else {
      return `R${num.toLocaleString('en-ZA')}`;
    }
  }


}
